import { createStore, compose, applyMiddleware } from "redux";
import logger from "redux-logger";
import reducer from "./reducers";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
if(!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  console.log("looks like redux dev tools it didn't install properly");
}

const store = function configureStore(initialState) {
  return createStore(reducer, initialState, composeEnhancer(applyMiddleware(logger)));
};

export default store;


// WEBPACK FOOTER //
// ./src/modules/store.js